import type { KnownKinds } from './types';

import { normalizeEntityRef } from './normalizeEntityRef';

/**
 * Compares two entity references for equality, normalizing them first.
 */
export const compareEntityRefs = (
  refA?: string,
  refB?: string,
  {
    defaultKind,
  }: {
    defaultKind?: KnownKinds;
  } = {},
): boolean => {
  if (!refA || !refB) {
    return false;
  }

  return (
    normalizeEntityRef(refA, defaultKind)
    === normalizeEntityRef(refB, defaultKind)
  );
};
